import React from 'react';
import {
  ContentProvider,
  DialogProvider,
  GoogleMapProvider,
  LangProvider,
  SnackbarProvider,
  UserProvider,
} from './providers';

const Provider = (props) => {
  const { children } = props;

  return (
    <LangProvider>
      <GoogleMapProvider>
        <SnackbarProvider>
          <DialogProvider>
            <UserProvider>
              <ContentProvider>{children}</ContentProvider>
            </UserProvider>
          </DialogProvider>
        </SnackbarProvider>
      </GoogleMapProvider>
    </LangProvider>
  );
};

export default Provider;
